/**
 * @architecture-header 1
 * @layer module
 * @domain reports
 * @responsibility Say in two columns what this report may and may not be used to decide.
 * @state-owner none
 * @allowed-imports React; shared components and hooks
 * @forbidden dataset mutations; direct API client
 * @public-api activity insight dialog
 * @side-effects none
 * @tests workspace Playwright flows in frontend/apps/web/e2e/workspace.spec.ts
 */

import { ModalDocument } from '../../../shared/components/Modal';
import { useOverlay } from '../../../shared/components/OverlayHost';
import { useTranslator } from '../../../shared/model/use-workspace';
import type { Caveat } from '../model/run-report';

const FIT: readonly string[] = [
  '找出這一次最多人卡住的題目，決定下一堂先講哪一題。',
  '挑出需要個別檢視作答的學生，點名字直接進去看他寫了什麼。',
  '在收齊之前，先掌握進度，判斷要不要延長時間。',
];

const UNFIT: readonly string[] = [
  '判斷某個學生的概念掌握程度。一題答錯不等於不會。',
  '比較兩個班或兩次評量。這張表只描述這一份。',
  '拿來當成績或分班依據。未收齊、判定未全部確認。',
];

export function ReportGuideDialog({ caveats = [] }: { caveats?: readonly Caveat[] }) {
  const t = useTranslator();
  const { closeModal } = useOverlay();

  return (
    <ModalDocument
      footer={
        <>
          <div className="sp" />
          <button className="bt pri" type="button" onClick={closeModal}>
            {t('知道了')}
          </button>
        </>
      }
      maxWidth={620}
      subtitle={t('同一張表，用對地方和用錯地方差很多')}
      title={t('報表判讀說明')}
    >
      <div className="rguse">
        <div>
          <h6 className="rgok">{t('適合拿來做的事')}</h6>
          <ul>
            {FIT.map((line) => (
              <li key={line}>{t(line)}</li>
            ))}
          </ul>
        </div>
        <div>
          <h6 className="rgno">{t('不適合拿來做的事')}</h6>
          <ul>
            {UNFIT.map((line) => (
              <li key={line}>{t(line)}</li>
            ))}
          </ul>
        </div>
      </div>
      {caveats.length ? (
        <>
          <h6 className="rglim">{t('這次資料的全部限制')}</h6>
          <ul className="rglist">
            {caveats.map((caveat) => (
              <li key={caveat.id}>{caveat.text}</li>
            ))}
          </ul>
        </>
      ) : null}
    </ModalDocument>
  );
}
